import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        'bolsa-color-primario': '#711810',
        'bolsa-color-gris': '#9a999d',
        'bolsa-color-mostaza': '#e6d9aa',
        'bolsa-green': '#3AC67D',
        'bolsa-guinda': '#711610',
        'bolsa-primary': '#1976D2'
      }
    }
  }
});
